<template>
    <v-layout column>
        <v-layout class="py-3 px-4">
            <v-flex xs6>
                <v-layout column class="subheading">
                    <v-flex class="font-weight-bold text-h6 mb-3">Customer Information</v-flex>
                    <v-layout class="my-1">
                        <v-flex xs4>
                            Name:
                        </v-flex>
                        <v-flex>
                            {{ creditCard.firstName }} {{ creditCard.lastName }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>
                            Billing Address:
                        </v-flex>
                        <v-flex>
                            {{ creditCard.billingAddress }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>
                            Billing State:
                        </v-flex>
                        <v-flex>
                            {{ creditCard.billingState }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>
                            Billing Postal Code:
                        </v-flex>
                        <v-flex>
                            {{ creditCard.billingZip }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>CC Type:</v-flex>
                        <v-flex xs4>
                            <span>{{ creditCardType }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>
                            Credit Card (last 4):
                        </v-flex>
                        <v-flex>
                            {{ last4(creditCard.ccNumber) }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>CC Expiration Date:</v-flex>
                        <v-flex xs4>
                            {{ creditCard.ccExpirationMonth }}/{{ creditCard.ccExpirationYear }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-1">
                        <v-flex xs4>CC CVV:</v-flex>
                        <v-flex xs4>
                            {{ creditCard.ccCVV }}
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
            <v-flex xs6>
                <v-layout column class="subheading">
                    <v-flex class="text-h6 mb-2 mx-3 font-weight-bold mb-3">Summary of Charges</v-flex>
                    <v-layout v-for="(subtotal, i) in cart" :key="i" class="px-3 pb-1 my-1">
                        <v-flex xs6>
                            Unit {{ subtotal.unit }}
                        </v-flex>
                        <v-flex xs1 class="text-sm-right pr-2">
                            ${{ parseFloat(subtotal.total).toFixed(2) }}
                        </v-flex>
                    </v-layout>
<!--                    @TODO: Uncomment when convenience fees are reactivated.-->
<!--                    <v-layout class="px-3 pt-1" align-center>-->
<!--                        <v-flex xs6>-->
<!--                            Convenience Fee:-->
<!--                        </v-flex>-->
<!--                        <v-flex xs1 class="text-sm-right pr-2">-->
<!--                            ${{ parseFloat(convenienceFees.dcPrice).toFixed(2) }}-->
<!--                        </v-flex>-->
<!--                    </v-layout>-->
                    <v-layout>
                        <v-flex xs7>
                            <v-divider class="mx-1 my-3" />
                        </v-flex>
                    </v-layout>
                    <v-layout class="subheading font-weight-bold pb-3 px-3">
                        <v-flex xs6>
                            Non-refundable Total Charges:
                        </v-flex>
                        <v-flex xs1 class="text-sm-right pr-2">
<!--                        @TODO: Uncomment when convenience fees are reactivated... and move the evaluation out of the template for godssakes smh @conor - Conor -->
<!--                        ${{ (totalCharges(cart) + parseFloat(convenienceFees.dcPrice)).toFixed(2) }}-->
                            ${{ totalCharges(cart).toFixed(2) }}
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout column v-if="currentStep === '3'">
            <v-layout class="mx-4">
                <v-btn
                    data-testid="payment-info-return-unit-select-btn"
                    class="payment-info-return-unit-select-btn ml-0 mr-3 mt-4 mb-0"
                    @click="unitSelect"
                >
                    <v-icon class="mr-2">navigate_before</v-icon>
                    Return to Unit Select
                </v-btn>
                <v-btn
                    data-testid="payment-info-return-payment-btn"
                    class="payment-info-return-payment-btn ml-0 mt-4 mb-0"
                    @click="paymentOptions"
                >
                    <v-icon class="mr-2">navigate_before</v-icon>
                    Return to Payment Options
                </v-btn>
            </v-layout>
        </v-layout>
    </v-layout>
</template>

<script>
/* eslint-disable no-return-assign */
import { mapState } from "vuex";

export default {
  props: [
    "currentStep",
    // "convenienceFees", @TODO: Uncomment when convenience fees are reactivated.
    "cart"
  ],

  methods: {
    last4(ccNumber) {
      if (ccNumber && ccNumber.length === 19) {
        return ccNumber.substr(15);
      } else if (ccNumber && ccNumber.length === 17) {
        return ccNumber.substr(13);
      }
    },

    totalCharges(arr) {
      return arr.reduce((acc, currVal) => {
        return acc += parseFloat(currVal.total);
      }, 0);
    },

    unitSelect() {
      this.$emit("unitSelect");
    },

    paymentOptions() {
      this.$emit("paymentOptions");
    }

  },

  computed: {
    ...mapState({
      creditCard: state => state.tenant.creditCard
    }),

    creditCardType() {
      switch (this.creditCard.ccType) {
        case "visa":
          return "Visa";
        case "master-card":
          return "MasterCard";
        case "discover":
          return "Discover";
        case "amex":
          return "American Express";
        default:
          return "";
      }
    }
  }
};
</script>

<style>

</style>
